// Página de una venta en taquilla: consulta el estado cada pocos segundos y recarga cuando se paga.
const POLL_MS = 3000;
let timer = null;

const stop = () => {
  if (timer) clearInterval(timer);
  timer = null;
};

const poll = (root) => {
  const url = root.dataset.statusUrl;
  if (!url) return;

  fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
    .then((response) => (response.ok ? response.json() : null))
    .then((data) => {
      if (!data) return;
      // Al pagarse o vencer, la vista del servidor ya trae los QR: recargamos.
      if (data.status !== 'pending' || !data.holding) {
        stop();
        if (window.Turbo) {
          window.Turbo.visit(window.location.href, { action: 'replace' });
        } else {
          window.location.reload();
        }
      }
    })
    .catch(() => undefined);
};

const mount = () => {
  stop();
  const root = document.querySelector('[data-controller="box-office-order"]');
  if (!root || root.dataset.paid === 'true') return;
  timer = setInterval(() => poll(root), POLL_MS);
};

// Formulario de nueva venta: el botón se habilita solo cuando DoorSale aceptaría los datos.
const saleIssues = (form) => {
  const name = form.querySelector('[name="sale[name]"]');
  const email = form.querySelector('[name="sale[email]"]');
  const phone = form.querySelector('[name="sale[phone]"]');
  const quantity = form.querySelector('[name="sale[quantity]"]');
  const issues = [];

  if (!name.value.trim()) issues.push('el nombre');
  if (!email.value.trim() && !phone.value.trim()) {
    issues.push('el correo o WhatsApp');
  } else {
    if (email.value.trim() && !email.checkValidity()) issues.push('un correo válido');
    // phoneInput ya deja solo los dígitos locales (la lada va en su selector).
    if (phone.value.trim() && !/^\d{10}$/.test(phone.value)) issues.push('un WhatsApp de 10 dígitos');
  }
  if (!form.querySelector('[name="sale[event_price_id]"]:checked')) issues.push('la categoría');
  if (!quantity.value || !quantity.checkValidity()) issues.push(`una cantidad entre ${quantity.min} y ${quantity.max}`);

  return issues;
};

const mountSaleForm = () => {
  const form = document.querySelector('[data-controller="box-office-sale"]');
  if (!form) return;

  const submit = form.querySelector('[type="submit"]');
  const status = form.querySelector('[data-box-office-sale-status]');
  const update = () => {
    const issues = saleIssues(form);
    submit.disabled = issues.length > 0;
    const list = issues.length > 1 ? `${issues.slice(0, -1).join(', ')} y ${issues[issues.length - 1]}` : issues[0];
    status.textContent = issues.length ? `Falta ${list}.` : '';
  };

  form.addEventListener('input', update);
  form.addEventListener('change', update);
  update();
};

document.addEventListener('turbo:load', mount);
document.addEventListener('turbo:load', mountSaleForm);
document.addEventListener('turbo:before-visit', stop);
document.addEventListener('turbo:before-cache', stop);
